module.exports = __webpack_public_path__ + "img/banner3_4_vi.ecac7e36.png";